import { render, staticRenderFns } from "./Zombie.vue?vue&type=template&id=4e9fdd06&scoped=true&"
import script from "./Zombie.vue?vue&type=script&lang=js&"
export * from "./Zombie.vue?vue&type=script&lang=js&"
import style0 from "./Zombie.vue?vue&type=style&index=0&id=4e9fdd06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fdd06",
  null
  
)

export default component.exports